export default __webpack_public_path__ + "static/10_Rooster-2de5d9d87b4f01c0142589c5356397b4.png";